import type { GameActions } from '../app/connection';
import type { GameState } from '../app/state';
import { playerName } from '../app/state';
import { Button } from '../ui/Button';
import { Standings } from '../ui/Standings';
import s from './screens.module.scss';

/**
 * La fin.
 *
 * Le classement final, et une seule action : recommencer. Un ecran de fin qui
 * propose trois choses fait sortir du jeu ; entre amis, on relance.
 *
 * Quitter ramene a l'accueil avec le nom deja memorise, donc deux clics
 * suffisent pour repartir a la meme table.
 */
export interface OverScreenProps {
  state: GameState;
  actions: GameActions;
}

export function OverScreen({ state, actions }: OverScreenProps) {
  const standings = state.finalStandings ?? [];
  const winner = [...standings].sort((a, b) => b.bankroll - a.bankroll)[0];

  return (
    <main className={s.over}>
      <header className={s.overHeader}>
        <span className={s.overLabel}>Partie terminee</span>
        {winner ? <h1 className={s.overWinner}>{playerName(state, winner.playerId)}</h1> : null}
      </header>

      <Standings state={state} standings={standings} podium />

      <footer className={s.overFooter}>
        <Button tone="action" size="lg" onClick={actions.leave}>
          Nouvelle partie
        </Button>
      </footer>
    </main>
  );
}
